import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import useTranslation from '@src/hooks/useTranslation';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';

import { SSO_TYPE_GOOGLE, SSO_TYPE_SELF_HOST, SSO_TYPE_SANWA } from '@src/const/common';
import { OauthGoogleIcon } from '@src/components/common/icon';
import Button from '@src/components/common/button';
import { ssoLoginUrl } from '@src/utils/hardcode';

import * as actions from '@src/store/actions';
import * as selectors from '@src/store/selectors';

import {
	Content, StyledLoginWrapper as LoginWrapper, InputContent, ButtonDesc,
	LoginTypeTabWrapper, LoginTypeTab, TitleText,
} from './style';
import Info from './info';

export const GoogleButton = styled.div`
  display: flex;
  justify-content: center;
	align-items: center;
	width: 320px;
	background: #FFFFFF;
	border: 1px solid #D2D2D2;
	border-radius: 2px;
	color: #676767;
	padding: 8px 0px;
	cursor: pointer;
	@media ${props => props.theme.device.mobile} {
		width: 293px;
	}
	&:hover {
		opacity: 0.8;
	}
`;

const StyleLogin = styled(Button)`
  padding: 10px;
	width: 175px;
	@media ${props => props.theme.device.mobile} {
		width: 100%;
	}
`;

const StyledLoginWrapper = styled(LoginWrapper)`
	display: flex;
	align-items: center;
`;

export const StyledOauthGoogleIcon = styled(OauthGoogleIcon)`
  margin-right: 18px;
`;

const BusinessSSOLogin = ({ type }: { type: string }): JSX.Element => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const router = useRouter();
	const domain = useSelector(selectors.getDomain) as string;

	const handleLogin = () => {
		dispatch(
			actions.addActionsToStash([
				{
					actionMethod: 'historyReplaceCall',
					// eslint-disable-next-line no-restricted-globals
					actionPayload: '/member',
				},
			]),
		);
		if (type === SSO_TYPE_GOOGLE) {
			dispatch(actions.socialLoginPrepareCall({ name: 'google' }));
		} else if (type === SSO_TYPE_SANWA) {
			dispatch(actions.socialLoginPrepareCall({ name: 'sanwa' }));
		}
	};

	const handleSelfHostLogin = () => {
		const url = ssoLoginUrl(domain.toLocaleLowerCase());
		if (url) window.location.href = url;
	};

	useEffect(() => {
		const { search } = window.location;
		const parsed = queryString.parse(search);
		const { token } = parsed as { token: string; };
		if (token && type === SSO_TYPE_SELF_HOST) {
			dispatch(
				actions.rfaLoginCall({
					token,
					onSuccess: () => router.push('/member'),
				}),
			);
		}
	}, []);

	return (
		<Content>
			<Info />
			<InputContent>
				<StyledLoginWrapper>
					<LoginTypeTabWrapper>
						<LoginTypeTab className="active">
							{t('all:employee_login')}
						</LoginTypeTab>
						<LoginTypeTab onClick={() => window.open('https://teaches.cc/admin/login', '_blank')}>
							{t('all:admin_login')}
						</LoginTypeTab>
					</LoginTypeTabWrapper>
					<TitleText>{`${t('business:login:sso_title')}`}</TitleText>
					{
						type === SSO_TYPE_GOOGLE && (
							<GoogleButton onClick={handleLogin}>
								<StyledOauthGoogleIcon />
								{`${t('business:login:sso_google_btn')}`}
							</GoogleButton>
						)
					}
					{
						type === SSO_TYPE_SELF_HOST && (
							<StyleLogin handleClick={handleSelfHostLogin}>
								{`${t('business:login:sso_self_host_btn')}`}
							</StyleLogin>
						)
					}
					{
						type === SSO_TYPE_SANWA && (
							<StyleLogin handleClick={handleLogin}>
								{`${t('business:login:sso_self_host_btn')}`}
							</StyleLogin>
						)
					}
					<ButtonDesc>
						{`${t('business:login:sso_desc')}`}
					</ButtonDesc>
				</StyledLoginWrapper>
			</InputContent>
		</Content>
	);
};

export default BusinessSSOLogin;
